export const tokens = {
    gap: {
        medium: 10,
        large: 20,
    },
    thumbnail: {
        size: {
            medium: 44,
            large: 84,
        },
        radius: {
            medium: 6,
            large: 12,
        },
    },
    textGap: {
        medium: 6,
        large: 12,
    },
    nameSize: {
        medium: 14,
        large: 22,
    },
    collectionSize: {
        medium: 12,
        large: 18,
    },
};
